import React from "react";
import { ReactComponent as ArrowUpIcon } from "./../../images/svg/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "./../../images/svg/arrowDown.svg";
import { gettext } from "../../adapter";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";

const AllStationsListHead = () => {
  const { search } = useLocation();
  const history = useHistory();

  const onClick = (sortProperty) => {
    let query = queryString.parse(search);
    var direction = "ASC";

    if (sortProperty !== "") {
      var oldSortProperty = query.sort;
      query.sort = sortProperty;

      if (!query.direction) {
        if (sortProperty === "name") {
          query.direction = "DESC";
        } else {
          query.direction = direction;
        }
      } else {
        if (query.direction === "ASC" && sortProperty === oldSortProperty) {
          direction = "DESC";
        }

        query.direction = direction;
      }
    } else {
      delete query.sort;
      delete query.direction;
    }

    history.push("?" + queryString.stringify(query));
  };

  let { sort, direction } = queryString.parse(search);
  if (!sort) sort = "name";
  if (!direction) direction = "ASC";

  var directionIcon = <ArrowUpIcon className="is-sorting" />;

  if (direction === "ASC") {
    directionIcon = <ArrowDownIcon className="is-sorting" />;
  }
  return (
    <thead>
      <tr>
        <th>
          <button className="link" onClick={onClick.bind(null, "name")}>
            {gettext("Name")}
          </button>{" "}
          {sort === "name" ? directionIcon : ""}
        </th>
        <th>{gettext("Latest Measurement")}</th>
      </tr>
    </thead>
  );
};

export default AllStationsListHead;
